import React from 'react'
import PropTypes from 'prop-types'
import {
  BannerContentWrapper,
  BannerWrapper,
  BannerText,
  BannerHeader,
  BreadcrumbRow,
  StyledTextLink,
} from './component.styles'
import { BACK_TO_DASHBOARD_TEXT } from './constants'
import SiteSelector, {
  SiteSelectorK8WrapperLight,
  DefaultSiteSelectorWrapper,
} from 'components/SiteSelector'
import { hasBreadcrumbLinks } from 'utils/breadcrumbHelpers'
import { isHighSchoolUrl } from 'utils/routing/routeHelpers'

export const LandingBanner = props => {
  const {
    breadcrumb,
    className,
    dataTestId = 'default-id',
    isHsSupports,
    shouldShowSiteSelector,
    navigateToDashboardOnClick,
    title,
    text,
    // TODO: revisit/refactor this logic when we receive final designs for
    //       the breadcrumb nav. the breadcrumb component itself could potentially
    //       handle when it renders
    isDistrict,
  } = props

  const dataTestIdPrefix = `landing-banner`
  const dataTestIdWrapper = `${dataTestIdPrefix}-wrapper-${dataTestId}`
  const dataTestIdHeader = `${dataTestIdPrefix}-header-${dataTestId}`
  const dataTestIdText = `${dataTestIdPrefix}-header-${dataTestId}`

  const isHighSchool = isHighSchoolUrl()
  const showBreadcrumb = hasBreadcrumbLinks(breadcrumb)
  const SiteSelectorWrapper = isHighSchool
    ? DefaultSiteSelectorWrapper
    : SiteSelectorK8WrapperLight

  return (
    <BannerWrapper
      $hasBreadcrumb={showBreadcrumb}
      className={className}
      data-has-breadcrumb={showBreadcrumb ? 'true' : undefined}
      data-testid={dataTestIdWrapper}
      isHsSupports={isHsSupports}
    >
      <BreadcrumbRow
        breadcrumb={breadcrumb}
        currentPageTitle={title}
        isLight={!isHighSchool}
      >
        {shouldShowSiteSelector && (
          <SiteSelectorWrapper>
            <SiteSelector />
          </SiteSelectorWrapper>
        )}
      </BreadcrumbRow>
      <BannerContentWrapper>
        {isDistrict && !showBreadcrumb && (
          <StyledTextLink
            dataTestId={'back-to-dashboard-link'}
            onClick={navigateToDashboardOnClick}
          >
            {BACK_TO_DASHBOARD_TEXT}
          </StyledTextLink>
        )}
        <BannerHeader data-testid={dataTestIdHeader}>{title}</BannerHeader>
        <BannerText align="center" data-testid={dataTestIdText}>
          {text}
        </BannerText>
      </BannerContentWrapper>
    </BannerWrapper>
  )
}

LandingBanner.propTypes = {
  breadcrumb: PropTypes.object,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  isDistrict: PropTypes.bool,
  isHsSupports: PropTypes.bool,
  navigateToDashboardOnClick: PropTypes.func.isRequired,
  shouldShowSiteSelector: PropTypes.bool,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default LandingBanner
